<template>
    <div :data-component="$options.name">
        <div class="h-full">
            <h2 class="mb-16 text-h3 font-bold-headline">Grundriss</h2>
            <div
                class="cursor-pointer relative"
                @click="openGallery()"
            >
                <img
                    class="object-cover screen-l:w-2/3 h-full"
                    :src="images[0].url"
                    :alt="images[0].description"
                />
                <cs-secondary-button
                    class="absolute flex-row bottom-16 left-16"
                    :isSmall="true"
                    :hasWhiteBackground="true"
                    :isCentered="true"
                >
                    <template #icon><ms-image /></template>
                    <template #default>{{ badgeText }}</template>
                </cs-secondary-button>
            </div>
        </div>
        <cs-gallery
            v-model:isVisible="galleryVisible"
            class="z-overlay-canvas"
            :images="images"
            :startIndex="0"
            :trackingParameter="galleryTracking"
        />
    </div>
</template>
<script lang="ts" src="./MsDetailFloorPlan.ts" />
